import { apiFetch } from './apiFetch';

export interface BoatType {
  id: string;
  slug: string;
  label: string;
  label_en?: string | null;
  label_de?: string | null;
  icon?: string | null;
  sort_order: number;
  is_active?: boolean;
  is_protected?: boolean;
  enabled_fields?: string[];
  created_at?: string;
  updated_at?: string;
}

// Public listing (active types only).
export const listBoatTypes = async (): Promise<BoatType[]> => {
  const res = await apiFetch<{ success: boolean; data: BoatType[] }>('/boat-types');
  return res.data || [];
};

// Admin CRUD.
export const adminListBoatTypes = async (): Promise<BoatType[]> => {
  const res = await apiFetch<{ success: boolean; data: BoatType[] }>('/admin/boat-types');
  return res.data || [];
};

export const adminCreateBoatType = async (payload: Partial<BoatType>): Promise<BoatType> => {
  const res = await apiFetch<{ success: boolean; data: BoatType }>('/admin/boat-types', {
    method: 'POST',
    body: JSON.stringify(payload),
  });
  return res.data;
};

export const adminUpdateBoatType = async (id: string, payload: Partial<BoatType>): Promise<BoatType> => {
  const res = await apiFetch<{ success: boolean; data: BoatType }>(`/admin/boat-types/${id}`, {
    method: 'PATCH',
    body: JSON.stringify(payload),
  });
  return res.data;
};

export const adminDeleteBoatType = async (id: string): Promise<void> => {
  await apiFetch(`/admin/boat-types/${id}`, { method: 'DELETE' });
};
